"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrimaryCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="primary-call-to-action" ref={ref} className="bg-background py-24 px-6 sm:px-12 lg:px-24">
      <div className={`max-w-3xl mx-auto text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-foreground mb-6 leading-tight">
          Stop guessing. Start fixing.
        </h2>
        <p className="text-lg sm:text-xl text-muted-foreground mb-10 leading-relaxed">
          Most practices stall because they work harder on the wrong problem. Guessing is the most
          expensive mistake you can make. Get clarity before execution begins.
        </p>
        <Link to="#contact-us-form">
          <Button size="lg" className="text-primary-foreground inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-10 rounded-md has-[>svg]:px-4 btn-primary text-base px-8 py-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] !text-[hsl(0,0%,100%)] !bg-[hsl(29,100%,50%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 sm:text-lg hover:bg-primary hover:border-primary">
            Book the Practice Growth Diagnostic
          </Button>
        </Link>
      </div>
    </section>;
}